import tmhRequest from "@/config/tmhRequest";

export default {
  searchListItemClassify: function(data) {
    return tmhRequest({
      url: "/project/tmh/itemclassify/searchlistitemclassify",
      method: "post",
      params: data
    });
  },
  searchItemClassifyTree: function(data) {
    return tmhRequest({
      url: "/project/tmh/itemclassify/searchitemclassifytree",
      method: "post",
      params: data
    });
  },

  addItemClassify: function(data) {
    return tmhRequest({
      url: "/project/tmh/itemclassify/additemclassify",
      method: "post",
      params: data
    });
  },

  editItemClassify: function(data) {
    return tmhRequest({
      url: "/project/tmh/itemclassify/edititemclassify",
      method: "post",
      params: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/tmh/item/itemclassify.js